import { useState } from 'react'
import { APP_TAGLINE } from '@/config'
import { Wordmark } from '@/components/Wordmark'
import { Button } from '@/components/Button'
import { GoogleIcon } from '@/components/icons'
import { pendingInvite } from '@/data/invites'
import { signInWithGoogle, useAuth } from '@/store/auth'
import './Onboarding.css'

export function SignInScreen() {
  const error = useAuth((s) => s.error)
  const [busy, setBusy] = useState(false)

  const onClick = async () => {
    setBusy(true)
    try {
      await signInWithGoogle()
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="onboard onboard--centre">
      <div className="onboard__brand">
        <h1 className="onboard__name">
          <Wordmark />
        </h1>
        <p className="onboard__tagline">{APP_TAGLINE}</p>
      </div>
      <div className="onboard__actions">
        <Button variant="secondary" size="lg" block onClick={onClick} disabled={busy}>
          <GoogleIcon />
          Continue with Google
        </Button>
        {pendingInvite() && <p className="onboard__note">You've been invited. Sign in with Google to start your household.</p>}
        {error && (
          <p className="onboard__error" role="alert">
            {error}
          </p>
        )}
      </div>
    </main>
  )
}
